var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: 0.75rem;\n  font-weight: 400;\n  text-align: ', '\n'], ['\n  font-size: 0.75rem;\n  font-weight: 400;\n  text-align: ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  left: 1px;\n  position: relative;\n  width: 100%;\n  margin-bottom: .5rem;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  left: 1px;\n  position: relative;\n  width: 100%;\n  margin-bottom: .5rem;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  flex: 1;\n  margin-left: -1px;\n  position: relative;\n\n  border: 1px solid  ', ';\n  color: ', ';\n  background-color: ', ';\n  cursor: pointer;\n  z-index: ', ';\n\n  &:hover {\n    border-color: ', ';\n    z-index: 9;\n  }\n\n  &::before {\n    content: "";\n    display: block;\n    padding-top: 100%;\n  }\n\n  span {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    transform: translateY(-50%);\n    font-size: .875rem;\n    font-weight: 600;\n  }\n'], ['\n  flex: 1;\n  margin-left: -1px;\n  position: relative;\n\n  border: 1px solid  ', ';\n  color: ', ';\n  background-color: ', ';\n  cursor: pointer;\n  z-index: ', ';\n\n  &:hover {\n    border-color: ', ';\n    z-index: 9;\n  }\n\n  &::before {\n    content: "";\n    display: block;\n    padding-top: 100%;\n  }\n\n  span {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    transform: translateY(-50%);\n    font-size: .875rem;\n    font-weight: 600;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import Theme from '../../../Theme';

var _Theme$colors = Theme.colors,
    pearlGrey = _Theme$colors.pearlGrey,
    lightBlue = _Theme$colors.lightBlue,
    white = _Theme$colors.white;

var NPSScoreRange = 11;

var Lead = styled.p(_templateObject, function (props) {
  return props.right && 'right';
});

var ScoreWrapper = styled.div(_templateObject2);

var ScoreBoxHolder = styled.div(_templateObject3, function (props) {
  return props.selected ? lightBlue : pearlGrey;
}, function (props) {
  return props.selected && white;
}, function (props) {
  return props.selected && lightBlue;
}, function (props) {
  return props.selected && '9';
}, lightBlue);

var ScoreBox = function ScoreBox(_ref) {
  var score = _ref.score,
      selected = _ref.selected,
      onClickHandler = _ref.onClickHandler;
  return React.createElement(
    ScoreBoxHolder,
    { selected: selected, onClick: function onClick() {
        return onClickHandler(score);
      } },
    React.createElement(
      'span',
      null,
      score
    )
  );
};

var ScoreCol = function ScoreCol(_ref2) {
  var onScoreClick = _ref2.onScoreClick,
      score = _ref2.score;
  return React.createElement(
    Col,
    { md: '6' },
    React.createElement(
      'p',
      null,
      'How likely are you to recommend this version of PGA.org to other Members?'
    ),
    React.createElement(
      ScoreWrapper,
      null,
      Array(NPSScoreRange).fill(0).map(function (_, ix) {
        return React.createElement(ScoreBox, { score: ix, key: 'score-box-' + ix, selected: score === ix, onClickHandler: onScoreClick });
      })
    ),
    React.createElement(
      Row,
      null,
      React.createElement(
        Col,
        { xs: '6' },
        React.createElement(
          Lead,
          null,
          'Not at all likely'
        )
      ),
      React.createElement(
        Col,
        { xs: '6' },
        React.createElement(
          Lead,
          { right: '1' },
          'Extremely likely'
        )
      )
    )
  );
};

ScoreCol.propTypes = process.env.NODE_ENV !== "production" ? {
  onScoreClick: PropTypes.func.isRequired,
  score: PropTypes.number
} : {};

export default ScoreCol;